import apiClient from './apiClient';
import type { ApiResponse } from '../types/api';

export interface ItbisType {
    id: number;
    code: string;
    name: string;
    rate: string | number;
    is_active: boolean;
    sort_order: number;
}

export interface UpdateItbisTypeRequest {
    name?: string;
    rate?: number;
    is_active?: boolean;
    sort_order?: number;
}

const ITBIS_TYPES_URL = '/itbis-types';

export const itbisTypeService = {
    async getAll(activeOnly = false): Promise<ItbisType[]> {
        const url = activeOnly ? `${ITBIS_TYPES_URL}?active=1` : ITBIS_TYPES_URL;
        const response = await apiClient.get<ApiResponse<ItbisType[]>>(url);
        return response.data.data;
    },

    async getActive(): Promise<ItbisType[]> {
        return this.getAll(true);
    },

    async update(id: number, data: UpdateItbisTypeRequest): Promise<ItbisType> {
        const response = await apiClient.put<ApiResponse<ItbisType>>(`${ITBIS_TYPES_URL}/${id}`, data);
        return response.data.data;
    },
};

export default itbisTypeService;
